import React from "react";

import isIntuit from "Intuit/isIntuit";
import { useDispatch, useSelector } from "react-redux";

import { Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter, closeModal } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Row, Col } from "Common/Grid";

import { SUCCESS_MODAL_NAME } from "./constants";

const SuccessModal = () => {
  const currentlyOpenModal = useSelector((state) => state.openModal);
  const dispatch = useDispatch();

  return (
    <Modal show={currentlyOpenModal === SUCCESS_MODAL_NAME} onHide={() => dispatch(closeModal(SUCCESS_MODAL_NAME))}>
      <ModalHeader closeButton onClick={() => dispatch(closeModal(SUCCESS_MODAL_NAME))}>
        <ModalTitle>Successful Upload</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <BodyText>The document you uploaded appears correct!</BodyText>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="blue" onClick={() => dispatch(closeModal(SUCCESS_MODAL_NAME))} {...(isIntuit() ? { size: "medium" } : {})}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SuccessModal;
